import apiClient from '../client'

export const subscriptionService = {
  list: async (params = {}) => {
    const response = await apiClient.get('/subscriptions', { params })
    return response.data
  },
}
